var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import FilterRule from './FilterRule';
/**
 *
 */
var FilterRuleArrayContains = /** @class */ (function (_super) {
    __extends(FilterRuleArrayContains, _super);
    /**
     *
     * @param param
     * @param isAny
     */
    function FilterRuleArrayContains(param, isAny) {
        if (isAny === void 0) { isAny = true; }
        var _this = _super.call(this, param) || this;
        _this.isAny = isAny;
        return _this;
    }
    /**
     *
     * @param object
     * @return {boolean}
     */
    FilterRuleArrayContains.prototype.apply = function (object) {
        if (!object) {
            return false;
        }
        if (!this.value || !this.parameter) {
            return true;
        }
        var objectValue = object[this.parameter];
        if (!objectValue) {
            return false;
        }
        if (!Array.isArray(objectValue)) {
            return false;
        }
        if (!Array.isArray(this.value)) {
            if (typeof (this.value) === 'string') {
                this.value = this.value.split(',');
            }
            else {
                throw new Error('Expected value should be an array, current value is: ' + this.value);
            }
        }
        if (this.value.length === 0) {
            return true;
        }
        // Find if all value in values array is found
        var allValuesFound = true;
        var anyValueFound = false;
        this.value.forEach(function (val) {
            var includes = objectValue.includes(val);
            if (!includes) {
                allValuesFound = false;
            }
            if (includes) {
                anyValueFound = true;
            }
        });
        return this.isAny ? anyValueFound : allValuesFound;
    };
    return FilterRuleArrayContains;
}(FilterRule));
export default FilterRuleArrayContains;
